/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ProductRecommendedWith = 'Website.ProductCrossSell.ProductRecommendedWith';
